'use client';
import { Text } from '~components/Typography';
import { routes } from '~constants/routes';
import { useCurrentBot } from '~hooks/useCurrentBot';

import { BotActions } from '../BotActions';
import { BotHeaderAvatar } from './BotHeaderAvatar';
import { BotHeaderContainer, BotLink } from './styles';
//can be server component if /getBot fn will work with UGC bots
export const BotHeader = ({ recipientId }: { recipientId: string }) => {
	const { bot } = useCurrentBot({ recipientId });

	return bot?.name ? (
		<BotHeaderContainer>
			<BotLink href={routes.profile.slug(bot.clientId)}>
				{bot.images?.chatAvatarPath && <BotHeaderAvatar images={bot.images} />}
				<Text as="h1" size="L">
					{bot.name}
				</Text>
			</BotLink>
			<BotActions />
		</BotHeaderContainer>
	) : null;
};
